import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';

import { AuthContext } from '../context/AuthContext';

const AdminProtectedRoute = ({ children }) => {
  const { usuario, authLoading } = useContext(AuthContext);
  const token = localStorage.getItem('token');
  const esAdmin = usuario?.role === 'admin' || Boolean(usuario?.is_superuser);

  if (authLoading) {
    return (
      <section className="container page-shell">
        <div className="surface-card">
          <p className="mb-0">Validando permisos de administrador...</p>
        </div>
      </section>
    );
  }

  if (!token || !usuario) {
    return <Navigate to="/login" replace />;
  }

  if (!esAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminProtectedRoute;
